<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Risk Management</h5>
                  <h2 class=" card-title"><i class="fab fa-sellsy fa-lg"></i>&nbsp;&nbsp;&nbsp; Analytics</h2>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div class="row">
                <div class="col-6 text-right" style="line-height: 48px; color: grey">
                  Analysis:
                </div>
                <mat-form-field>
                  <mat-select [(value)]="metricsPivot">
                    <mat-option value="three_years">Three Years</mat-option>
                    <mat-option value="one_year">One Year</mat-option>
                    <mat-option value="yearly">Yearly</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <br>
              <div *ngFor="let pivot of ['yearly','one_year','three_years']">
                <!-- Metrics bar chart -->
                <app-basic-bar-chart *ngIf="pivot == metricsPivot &&
                                        investableMA[metricsPivot]"
                                     [series]="[
                                    {label: 'maximum_loss',     values: getFormattedPeriodValues('investable','maximum_loss',false,pivot)},
                                    {label: 'maximum_drawdown', values: getFormattedPeriodValues('investable','maximum_drawdown',false,pivot)}
                                  ]" opposite percent>
                </app-basic-bar-chart>
                <!-- Metrics bar chart -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>
      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-center">
                    <h2 class=" card-title text-primary">Analytics</h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">
                <!-- Metrics table -->
                <table *ngIf="investableMA" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let period of getFormattedPeriods()">
                      {{ period }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th class="casino" scope="row">Returns</th>
                    <td *ngFor="let returns of getPeriodValues('investable','returns')">
                      {{ returns | percent:'.1' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="casino" scope="row">Volatility</th>
                    <td *ngFor="let volatility of getPeriodValues('investable','volatility')">
                      {{ volatility | percent:'.1' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="casino" scope="row">Max Loss</th>
                    <td *ngFor="let maximum_loss of getPeriodValues('investable','maximum_loss')">
                      {{ maximum_loss | percent:'.1' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="casino" scope="row">Max Drawdown</th>
                    <td *ngFor="let maximum_drawdown of getPeriodValues('investable','maximum_drawdown')">
                      {{ maximum_drawdown | percent:'.1' }}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- Metrics table -->

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}
                  </em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <br>
  </div>
</div>
